"use client";
import Image from "next/image"
import Reveal from "../../components/Reveal"
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import { useTranslations } from "next-intl";
import { useWindowSize } from "@/hooks/common/useWindowSize";
import Link from "next/link";
import { useRouter } from "next/navigation";

const data = [
    {
        id: 1,
        imgUrl: "/images/backgrounds/thumbnail.png",
        label: "News",
        readTime: "5 min read",
        title: "Those who participate and benefit from this network",
        subTitle: "The world is witnessing an explosion of artificial intelligence (AI). However, the hardware infrastructure to support AI is becoming scarce and expensive. Businesses face enormous costs and difficulties in accessing these resources."
    },
    {
        id: 2,
        imgUrl: "/images/backgrounds/thumbnail1.png",
        label: "News",
        readTime: "5 min read",
        title: "Those who participate and benefit from this network",
        subTitle: "The world is witnessing an explosion of artificial intelligence (AI). However, the hardware infrastructure to support AI is becoming scarce and expensive. Businesses face enormous costs and difficulties in accessing these resources."
    },
    {
        id: 3,
        imgUrl: "/images/backgrounds/thumbnail2.png",
        label: "News",
        readTime: "5 min read",
        title: "Those who participate and benefit from this network",
        subTitle: "The world is witnessing an explosion of artificial intelligence (AI). However, the hardware infrastructure to support AI is becoming scarce and expensive. Businesses face enormous costs and difficulties in accessing these resources."
    },
]

const HelpfulRes = ({ news }: { news: any }) => {
  const t = useTranslations('invester');
  const { width } = useWindowSize();
  console.log(news);
  const data = [
    {
      id: 1,
      imgUrl: "/images/backgrounds/thumbnail.png",
      label: "News",
      readTime: "5 min read",
      title: "Those who participate and benefit from this network",
      subTitle:
        "The world is witnessing an explosion of artificial intelligence (AI). However, the hardware infrastructure to support AI is becoming scarce and expensive. Businesses face enormous costs and difficulties in accessing these resources.",
    },
    {
      id: 2,
      imgUrl: "/images/backgrounds/thumbnail1.png",
      label: "News",
      readTime: "5 min read",
      title: "Those who participate and benefit from this network",
      subTitle:
        "The world is witnessing an explosion of artificial intelligence (AI). However, the hardware infrastructure to support AI is becoming scarce and expensive. Businesses face enormous costs and difficulties in accessing these resources.",
    },
    {
      id: 3,
      imgUrl: "/images/backgrounds/thumbnail2.png",
      label: "News",
      readTime: "5 min read",
      title: "Those who participate and benefit from this network",
      subTitle:
        "The world is witnessing an explosion of artificial intelligence (AI). However, the hardware infrastructure to support AI is becoming scarce and expensive. Businesses face enormous costs and difficulties in accessing these resources.",
    },
]

  const handleImageUrl = (blogData: any) => {
    const imgSource = blogData?.attributes?.image?.data?.attributes?.formats;
    return blogData?.attributes?.image?.data?.attributes?.url ||
    (width < 768
      ? imgSource?.small?.url
      : width >= 768 && width < 1280
      ? imgSource?.medium?.url
      : imgSource?.large?.url) ||
    imgSource?.thumbnail?.url ||
    blogData?.attributes?.image?.data?.attributes?.url;
  };

  const router = useRouter();
  const handleClick = (slug: string, id: number) => {
    router.push(`/news/${slug}-${id}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="py-[120px] max-lg:py-[56px] px-[78px] max-lg:px-10 max-sm:px-4 max-w-[1440px] mx-auto">
        <div className="flex justify-between items-center">
            <Reveal 
                delay={0.1} 
                duration={0.8} 
                direction="left"
                withBlur={true}
                blurAmount={8}
            >
                <h2 className="text-[48px]/[56px] max-lg:text-[32px]/[40px] max-sm:text-xl">{t('helpful-resources')}</h2>
            </Reveal>
            <Link href={"/news"} className="flex gap-2 cursor-pointer rounded-[8px] border-[2px] border-[#E9F3FF] py-3 max-sm:py-1 px-4 max-sm:px-2">
                <p className="font-medium text-sm text-[#06f] text-nowrap">{t('see-more')}</p>
                <Image
                    src={"/images/icons/arrow-up-right.svg"}
                    width={16}
                    height={16}
                    alt="arrow-icon" 
                />
            </Link>
        </div>

        {/* desktop */}
        <div className="mt-10 grid grid-cols-3 gap-6 max-lg:hidden">
            {news?.data?.map((item: any, index: any) => (
                <div key={index} onClick={() => handleClick(item?.attributes?.slug, item?.id)}>
                  <motion.div
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ 
                          duration: 0.6, 
                          ease: "easeOut", 
                          delay: index * 0.2
                      }}
                      viewport={{ once: true }}
                      className="w-full max-w-[600px] cursor-pointer"
                  >
                      <div className="lg:h-[230px] rounded-lg overflow-hidden">
                        <Image 
                          src={
                            handleImageUrl(item)
                            ? `${process.env.NEXT_PUBLIC_BASE_API}${handleImageUrl(item)}`
                            : "/images/demo/news-image.jpg"
                          } 
                          width={500} 
                          height={300} 
                          alt="thumbnail"
                          className="object-cover h-full"
                        />
                      </div>
                      <div className="flex flex-col gap-4 mt-6">
                          <div className="flex gap-4">
                              <p className="text-sm text-[#06f]">News</p>
                              <p className="text-sm font-light text-[#646464]">{item?.attributes?.timeRead?.split(" ")?.at(0) || 5}{" "} min read</p>
                          </div>
                          <p className="text-[22px]/[30px] font-bold text-[#202020] tracking-[-0.5px] line-clamp-2">{item?.attributes?.title}</p>
                          <p className='font-light text-sm text-[#646464] sm:line-clamp-2 hidden'>
                                {item?.attributes?.brief}
                            </p>
                      </div>
                  </motion.div>
                </div>
            ))}
        </div>

        {/* tablet- mobile */}
        <div className="lg:hidden mt-10">
  <Swiper
    modules={[FreeMode]}
    freeMode={{ enabled: true }}
    slidesPerView="auto"
    spaceBetween={16}
    grabCursor
    className="!overflow-visible px-4"
  >
    {news?.data?.map((item: any, index: any) => (
      <SwiperSlide key={index} className="!w-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.5,
            ease: "easeOut",
            delay: index * 0.1,
          }}
          viewport={{ once: true }}
          className="w-[280px] sm:w-[320px]"
        >
          <div className="h-[230px] max-sm:h-[180px] rounded-lg overflow-hidden">
            <Image 
              src={
                handleImageUrl(item)
                ? `${process.env.NEXT_PUBLIC_BASE_API}${handleImageUrl(item)}`
                : "/images/demo/news-image.jpg"
              } 
              width={500} 
              height={300} 
              alt="thumbnail"
              className="object-cover h-full"
            />
          </div>
          <div className="flex flex-col gap-4 mt-4">
            <div className="flex gap-4">
              <p className="text-sm text-[#06f]">News</p>
              <p className="text-sm font-light text-[#646464]">{item?.attributes?.timeRead?.split(" ")?.at(0) || 5}{" "} min read</p>
            </div>
            <p className="text-[20px]/[28px] font-bold text-[#202020] tracking-[-0.5px] line-clamp-2">
              {item?.attributes?.title}
            </p>
            <p className="text-sm font-light text-[#646464] line-clamp-2">{item?.attributes?.brief}</p>
          </div>
        </motion.div>
      </SwiperSlide>
    ))}
  </Swiper>
</div>
    </section>
  );
};

export default HelpfulRes;
